import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Header from './components/Header';
import HomePage from './components/HomePage';
import CorporateTravel from './components/CorporateTravel';
import Footer from './components/Footer';
import FloatingEnquiry from './components/FloatingEnquiry';
import WhatsAppFloat from './components/WhatsAppFloat';
import ScrollToTop from './components/ScrollToTop';
import TermsAndConditions from './components/TermsAndConditions';
import PrivacyPolicy from './components/PrivacyPolicy';
import PackageDetails from './components/PackageDetails';
import { WEBSITE_INFO } from './constants';

function App() {
  const [isTermsOpen, setIsTermsOpen] = useState(false);
  const [isPrivacyOpen, setIsPrivacyOpen] = useState(false);
  const [isPackageDetailsOpen, setIsPackageDetailsOpen] = useState(false);
  const [selectedPackage, setSelectedPackage] = useState(null);
  const [isEnquiryOpen, setIsEnquiryOpen] = useState(false);
  const [enquiryPackageData, setEnquiryPackageData] = useState(null);

  const handlePackageEnquiry = (packageData) => {
    setEnquiryPackageData(packageData);
    setIsEnquiryOpen(true);
  };

  useEffect(() => {
    // Set document title and meta description
    document.title = WEBSITE_INFO.TITLE;
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', WEBSITE_INFO.DESCRIPTION);
    }
    const metaThemeColor = document.querySelector('meta[name="theme-color"]');
    if (metaThemeColor) {
      metaThemeColor.setAttribute('content', WEBSITE_INFO.THEME_COLOR);
    }
  }, []);

  return (
    <Router>
      <div className="App">
        <Header />
        
        <Routes>
          <Route path="/" element={
            <HomePage 
              setSelectedPackage={setSelectedPackage}
              setIsPackageDetailsOpen={setIsPackageDetailsOpen}
              setEnquiryPackageData={setEnquiryPackageData}
              setIsEnquiryOpen={setIsEnquiryOpen}
            />
          } />
          <Route path="/corporate-travel" element={
            <CorporateTravel 
              setEnquiryPackageData={setEnquiryPackageData}
              setIsEnquiryOpen={setIsEnquiryOpen}
            />
          } />
        </Routes>

        <Footer 
          onTermsClick={() => setIsTermsOpen(true)}
          onPrivacyClick={() => setIsPrivacyOpen(true)}
        />
        
        {/* Scroll to Top Button */}
        <ScrollToTop hideButton={isPackageDetailsOpen} />
        
        {/* Floating WhatsApp Button */}
        <WhatsAppFloat />        {/* Floating Enquiry Button */}
        <FloatingEnquiry 
          isOpen={isEnquiryOpen}
          onClose={() => {
            setIsEnquiryOpen(false);
            setEnquiryPackageData(null);
          }}
          packageData={enquiryPackageData}
          hideFloatingButton={isPackageDetailsOpen}
        />

        {/* Terms and Conditions Modal */}
        <TermsAndConditions 
          isOpen={isTermsOpen} 
          onClose={() => setIsTermsOpen(false)} 
        />

        {/* Privacy Policy Modal */}
        <PrivacyPolicy 
          isOpen={isPrivacyOpen} 
          onClose={() => setIsPrivacyOpen(false)} 
        />

        {/* Package Details Modal */}
        <PackageDetails 
          isOpen={isPackageDetailsOpen} 
          onClose={() => setIsPackageDetailsOpen(false)} 
          packageData={selectedPackage}
          onEnquiryClick={handlePackageEnquiry}
        />
      </div>
    </Router>
  );
}

export default App;